import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCallToPrinter,
} from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import { convertToTwoDecimals } from "../../shared/utility";

export function BarcodeHistoryViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState({
    serial: null,
    on_hand_net_kg: null,
    statusReason: null,
    stock_unit_of_measurement: null,
    on_hand_piece_count: null,
    name: null,
    created_date: null,
    barcode: null,
    barcode_histories: null,
    id: null,
    itemType: null,
  });

  const getBarcodeHistory = async function (barcode) {
    if (barcode.trim().length === 0) {
      showErrorModal("Barcode cannot be empty");
      return;
    }
    setLoading(true);
    let callResult = await makeGetApiCall(`barcodeHistory/${barcode}`, {});

    if (callResult.success) {
      setTimeout(function () {
        if (callResult.data.type === "pallet") {
          const item = callResult.data.pallet;
          setProduct({
            id: item.id,
            itemType: "pallet",
            serial: item.serial,
            plu: item.plu,
            on_hand_net_kg: convertToTwoDecimals(item.on_hand_net_kg),
            statusReason: item.statusReason,
            stock_unit_of_measurement: item.stock_unit_of_measurement,
            on_hand_piece_count: convertToTwoDecimals(
              item.on_hand_piece_count,
              0
            ),
            name: item.product_name,
            lot_number: item.lot_number,
            created_date: item.created_date,
            lastScanDate: item.lastScanDate,
            barcode: item.barcode,
            barcode_histories: callResult.data.barcode_histories,
            warehouse_location_name: item.warehouse_location_name,
            total_cartons: item.total_cartons,
            inv_on_hand_by_plu: item.inv_on_hand_by_plu,
            inv_on_hand_by_lot: item.inv_on_hand_by_lot,
            label_image_zpl: item.label_image_zpl ?? "",
            tare_weight_kg: item.tare_weight_kg,
            best_before_date: item.best_before_date,
            produced_net_kg: item.produced_net_kg,
            produced_net_lbs: item.produced_net_lbs,
            produced_piece_count: item.produced_piece_count,
          });
        } else {
          const item = callResult.data.manufactured_item;
          setProduct({
            id: item.id,
            itemType: "manufactured",
            serial: item.serial,
            plu: item.plu,
            on_hand_net_kg: convertToTwoDecimals(item.on_hand_net_kg),
            statusReason: item.statusReason,
            stock_unit_of_measurement: item.stock_unit_of_measurement,
            on_hand_piece_count: convertToTwoDecimals(
              item.on_hand_piece_count,
              0
            ),
            name: item.product_name,
            lot_number: item.lot_number,
            created_date: item.created_date,
            lastScanDate: item.lastScanDate,
            barcode: item.barcode,
            barcode_histories: callResult.data.barcode_histories,
            warehouse_location_name: item.warehouse_location_name,
            total_cartons: 1,
            inv_on_hand_by_plu: item.inv_on_hand_by_plu,
            inv_on_hand_by_lot: item.inv_on_hand_by_lot,
            label_image_zpl: item.label_image_zpl ?? "",
            tare_weight_kg: item.tare_weight_kg,
            best_before_date: item.best_before_date,
            produced_net_kg: item.produced_net_kg,
            produced_net_lbs: item.produced_net_lbs,
            produced_piece_count: item.produced_piece_count,
          });
        }
      }, 250);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setLoading(false);
  };

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  async function reprintLabel() {
    if (!product.barcode) {
      showErrorModal("No barcode loaded to reprint");
      return;
    }

    const callResult = await makePostApiCallToPrinter({
      plu: product.plu,
      name_en: product.name,
      lot_number: product.lot_number,
      tare_weight: product.tare_weight_kg,
      best_before_date: product.best_before_date,
      piece_count: product.produced_piece_count,
      weight_in_kg: product.produced_net_kg,
      weight_in_lbs: product.produced_net_lbs,
      barcode_str: product.barcode,
      label_image_zpl: product.label_image_zpl ?? "",
      is_sample: false,
    });

    if (!callResult.success) {
      if (callResult.errorStatus === 401) {
        logout();
      }
      const message =
        callResult.data?.message ||
        callResult.data?.error ||
        callResult.data?.subtitle ||
        callResult.data?.data?.subtitle ||
        "Could not print label. Is the printer service running?";
      showErrorModal(message);
    }
  }

  return {
    product,
    getBarcodeHistory,
    loading,
    emptyModal,
    setEmptyModelOpen,
    reprintLabel,
  };
}
